var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceWithBorder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4365",
    "data-name": "Group 4365",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    fill: "#fff8e4",
    stroke: "#ffc629",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 73,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4017",
    "data-name": "Group 4017",
    transform: "translate(36.689 37.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3999",
    "data-name": "Group 3999",
    transform: "translate(0.648 15.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3996",
    "data-name": "Group 3996",
    transform: "translate(1.365 1.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M51.751,720.287c-1.61.974-1.65,3.069-.09,4.678l3.719,3.836a3.889,3.889,0,0,0,3.647,1.108,11.682,11.682,0,0,1,10.938,3.332c2.925,3.017,3.319,6.8,1.224,9.211a2.25,2.25,0,0,0,.4,3.07l3.719,3.836c1.561,1.609,4.131,2.124,5.741,1.15l41.681-25.22c1.61-.974,1.65-3.069.09-4.678l-3.719-3.836a3.893,3.893,0,0,0-3.647-1.108,11.683,11.683,0,0,1-10.938-3.332c-2.925-3.017-3.32-6.8-1.224-9.211a2.248,2.248,0,0,0-.4-3.07l-3.719-3.836c-1.561-1.609-4.131-2.124-5.741-1.15Z",
    transform: "translate(-50.517 -694.575)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3997",
    "data-name": "Group 3997",
    transform: "translate(1.365 1.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M119.106,716.774a3.893,3.893,0,0,0-3.647-1.108,11.684,11.684,0,0,1-10.939-3.332c-2.925-3.017-3.319-6.8-1.223-9.211a2.248,2.248,0,0,0-.4-3.07l-3.719-3.836c-1.561-1.609-4.131-2.124-5.741-1.15l-41.681,25.22c-1.61.974-1.65,3.069-.09,4.678l3.719,3.836a3.888,3.888,0,0,0,3.647,1.108,11.683,11.683,0,0,1,10.939,3.332c2.925,3.017,3.319,6.8,1.224,9.211a2.25,2.25,0,0,0,.4,3.07l3.72,3.836a5.138,5.138,0,0,0,5.271,1.378l40.4-32.024Z",
    transform: "translate(-50.517 -694.575)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3998",
    "data-name": "Group 3998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M73,746.235a6.824,6.824,0,0,1-4.8-2.056l-3.719-3.836a3.6,3.6,0,0,1-.454-4.916c1.661-1.91,1.179-4.938-1.174-7.364-2.493-2.571-6.527-3.819-9.593-2.967a5.236,5.236,0,0,1-4.993-1.473l-3.72-3.836a4.906,4.906,0,0,1-1.5-3.989,3.811,3.811,0,0,1,1.86-2.808L86.59,687.77c2.157-1.3,5.42-.7,7.428,1.368l3.719,3.836a3.6,3.6,0,0,1,.454,4.916c-1.661,1.91-1.179,4.938,1.173,7.364,2.493,2.572,6.528,3.819,9.593,2.967a5.236,5.236,0,0,1,4.993,1.473l3.72,3.836a4.906,4.906,0,0,1,1.5,3.989,3.809,3.809,0,0,1-1.86,2.808l-13.9,8.409A1.365,1.365,0,0,1,102,726.4l13.9-8.409a1.1,1.1,0,0,0,.566-.821,2.257,2.257,0,0,0-.749-1.738l-3.72-3.836a2.548,2.548,0,0,0-2.3-.743c-4.034,1.122-9.086-.4-12.285-3.7-3.38-3.486-3.9-8.033-1.273-11.057.228-.262.079-.776-.354-1.223l-3.72-3.836c-1.1-1.136-3-1.572-4.054-.932l-41.681,25.22a1.1,1.1,0,0,0-.566.822,2.258,2.258,0,0,0,.749,1.738l3.719,3.836a2.549,2.549,0,0,0,2.3.743c4.034-1.122,9.086.4,12.285,3.7,3.38,3.486,3.9,8.033,1.273,11.057-.228.262-.079.777.354,1.223l3.719,3.836c1.1,1.136,3,1.572,4.054.932L97.4,729.183a1.365,1.365,0,0,1,1.414,2.336L75.626,745.547A5.055,5.055,0,0,1,73,746.235Z",
    transform: "translate(-43.016 -687.081)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4016",
    "data-name": "Group 4016",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4000",
    "data-name": "Group 4000",
    transform: "translate(1.365 1.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M48.1,651.881a3.893,3.893,0,0,0,0,5.505l3.623,3.623a2.88,2.88,0,0,0,3.5.442A8.653,8.653,0,0,1,67.074,673.3a2.884,2.884,0,0,0,.442,3.5l3.623,3.623a3.892,3.892,0,0,0,5.505,0L116,641.075a3.893,3.893,0,0,0,0-5.505l-3.623-3.623a2.884,2.884,0,0,0-3.5-.442,8.653,8.653,0,0,1-11.847-11.847,2.88,2.88,0,0,0-.442-3.5l-3.623-3.623a3.892,3.892,0,0,0-5.505,0Z",
    transform: "translate(-46.96 -611.39)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001",
    transform: "translate(25.083 21.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M222.56,729.651a3.893,3.893,0,0,0,0-5.505l-3.623-3.623a2.883,2.883,0,0,0-3.39-.506l3.707,3.707a2.451,2.451,0,0,1,0,3.466l-40.371,40.371a3.875,3.875,0,0,1-1.642.979l.463.462a3.892,3.892,0,0,0,5.505,0Z",
    transform: "translate(-177.241 -719.68)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002",
    transform: "translate(44.095 1.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M285.4,618.218a8.653,8.653,0,0,0,6.123,12.94,8.659,8.659,0,0,1-2.519-11.5,2.88,2.88,0,0,0-.442-3.5l-3.623-3.623a3.886,3.886,0,0,0-3.267-1.105l3.287,3.287A2.88,2.88,0,0,1,285.4,618.218Z",
    transform: "translate(-281.675 -611.394)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003",
    transform: "translate(18.96 51.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M149.734,901.239a8.653,8.653,0,0,0-6.125-12.941,8.66,8.66,0,0,1,2.52,11.5,2.884,2.884,0,0,0,.442,3.5l3.623,3.623a3.886,3.886,0,0,0,3.269,1.105l-3.287-3.287A2.884,2.884,0,0,1,149.734,901.239Z",
    transform: "translate(-143.609 -888.298)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4004",
    "data-name": "Group 4004",
    transform: "translate(1.365 1.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M96.579,616.153l-3.623-3.623a3.892,3.892,0,0,0-5.505,0L48.1,651.881a3.893,3.893,0,0,0,0,5.505l3.623,3.623a2.88,2.88,0,0,0,3.5.442q.173-.1.349-.195l-3.449-3.448a2.451,2.451,0,0,1,0-3.466l38.507-38.507a2.451,2.451,0,0,1,3.466,0l3.2,3.2A2.878,2.878,0,0,0,96.579,616.153Z",
    transform: "translate(-46.96 -611.39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4009",
    "data-name": "Group 4009",
    transform: "translate(9.602 32.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4005",
    "data-name": "Group 4005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M97.645,786.642a1.361,1.361,0,0,1-.965-.4L92.6,782.164a1.365,1.365,0,0,1,1.931-1.931l4.078,4.078a1.365,1.365,0,0,1-.965,2.331Z",
    transform: "translate(-92.202 -779.834)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4006",
    "data-name": "Group 4006",
    transform: "translate(8.156 8.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M142.445,831.441a1.361,1.361,0,0,1-.965-.4l-4.078-4.078a1.365,1.365,0,0,1,1.931-1.931l4.078,4.078a1.365,1.365,0,0,1-.965,2.331Z",
    transform: "translate(-137.002 -824.633)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4007",
    "data-name": "Group 4007",
    transform: "translate(16.311 16.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M187.245,876.242a1.361,1.361,0,0,1-.965-.4l-4.078-4.078a1.365,1.365,0,1,1,1.931-1.931l4.078,4.078a1.365,1.365,0,0,1-.965,2.331Z",
    transform: "translate(-181.802 -869.433)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4008",
    "data-name": "Group 4008",
    transform: "translate(24.467 24.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M232.045,921.042a1.362,1.362,0,0,1-.965-.4L227,916.564a1.365,1.365,0,1,1,1.931-1.931l4.078,4.078a1.365,1.365,0,0,1-.965,2.331Z",
    transform: "translate(-226.602 -914.233)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4010",
    "data-name": "Group 4010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M67.757,676.81a5.223,5.223,0,0,1-3.718-1.54l-3.623-3.623a4.247,4.247,0,0,1-.653-5.163,7.288,7.288,0,0,0-9.977-9.977,4.248,4.248,0,0,1-5.163-.653L41,652.23a5.258,5.258,0,0,1,0-7.436l32.215-32.215a1.365,1.365,0,0,1,1.931,1.931L42.93,646.725a2.527,2.527,0,0,0,0,3.574l3.623,3.623a1.517,1.517,0,0,0,1.844.232,10.019,10.019,0,0,1,13.717,13.717,1.517,1.517,0,0,0,.232,1.844l3.623,3.623a2.53,2.53,0,0,0,3.574,0L108.9,633.987a2.53,2.53,0,0,0,0-3.574l-3.623-3.623a1.517,1.517,0,0,0-1.844-.232,10.019,10.019,0,0,1-13.717-13.717A1.516,1.516,0,0,0,89.479,611l-3.623-3.623a2.53,2.53,0,0,0-3.574,0,1.365,1.365,0,0,1-1.931-1.931,5.264,5.264,0,0,1,7.436,0l3.623,3.623a4.247,4.247,0,0,1,.653,5.163,7.288,7.288,0,0,0,9.978,9.978,4.248,4.248,0,0,1,5.163.652l3.623,3.624a5.264,5.264,0,0,1,0,7.436L71.475,675.27A5.223,5.223,0,0,1,67.757,676.81Z",
    transform: "translate(-39.459 -603.905)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4011",
    "data-name": "Group 4011",
    transform: "translate(36.414 4.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M240.848,630.7a1.365,1.365,0,0,1-.965-2.331l1.019-1.02a1.365,1.365,0,1,1,1.931,1.931l-1.019,1.019A1.361,1.361,0,0,1,240.848,630.7Z",
    transform: "translate(-239.482 -626.954)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4015",
    "data-name": "Group 4015",
    transform: "translate(26.933 20.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4012",
    "data-name": "Group 4012",
    transform: "translate(8.156 8.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M233.568,780.037a1.365,1.365,0,0,1-.965-2.331l14.272-14.273a1.365,1.365,0,0,1,1.931,1.931l-14.272,14.272A1.361,1.361,0,0,1,233.568,780.037Z",
    transform: "translate(-232.202 -763.034)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4013",
    "data-name": "Group 4013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M188.767,735.236a1.365,1.365,0,0,1-.965-2.331l14.272-14.273A1.365,1.365,0,1,1,204,720.564l-14.273,14.273A1.361,1.361,0,0,1,188.767,735.236Z",
    transform: "translate(-187.402 -718.233)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4014",
    "data-name": "Group 4014",
    transform: "translate(4.078 4.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M211.167,757.636a1.365,1.365,0,0,1-.965-2.331l14.272-14.273a1.366,1.366,0,0,1,1.931,1.931l-14.272,14.272A1.361,1.361,0,0,1,211.167,757.636Z",
    transform: "translate(-209.801 -740.633)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceWithBorder);
export default __webpack_public_path__ + "static/media/priceWithBorder.4f8ca48788971252c6e79ddd064f18a7.svg";
export { ForwardRef as ReactComponent };